import { normalizeProvider } from "@smithy/util-middleware";
import { toEndpointV1 } from "./adaptors/toEndpointV1";
export const resolveEndpointConfig = input => {
  var _input$tls, _input$useDualstackEn, _input$useFipsEndpoin;
  const tls = (_input$tls = input.tls) !== null && _input$tls !== void 0 ? _input$tls : true;
  const {
    endpoint
  } = input;
  const customEndpointProvider = endpoint != null ? async () => toEndpointV1(await normalizeProvider(endpoint)()) : undefined;
  const isCustomEndpoint = !!endpoint;
  return {
    ...input,
    endpoint: customEndpointProvider,
    tls,
    isCustomEndpoint,
    useDualstackEndpoint: normalizeProvider((_input$useDualstackEn = input.useDualstackEndpoint) !== null && _input$useDualstackEn !== void 0 ? _input$useDualstackEn : false),
    useFipsEndpoint: normalizeProvider((_input$useFipsEndpoin = input.useFipsEndpoint) !== null && _input$useFipsEndpoin !== void 0 ? _input$useFipsEndpoin : false)
  };
};